import styled from 'styled-components';

export const NavContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 120px;
`;

export const Section = styled.div`
  width: 100%;
  margin: 50px 50px;
  display: flex;
  justify-content: space-evenly;
`;
